import { entityEffects, selectCurrentEntity, selectEntityDisplayName } from '@opengov/app-core/entity';
import { coreFeatureFlagEffects } from '@opengov/app-core/featureFlag';
import { ensureAll } from '@opengov/compose-app-router/onEnter';
import { routerActions } from '@opengov/compose-app-router/state';
import { createSelector } from '@opengov/compose-app/reselect';
import { IEntity } from '@opengov/og-api-ts';
import { generatePageTitle } from '@opengov/stories-shared/utils';

import { onEnterStoriesRoutes } from '../routes/onEnter';
import { storyListPath } from '../routes/paths';

import { Maintenance } from './Maintenance';
import { selectMaintenanceProps } from './maintenanceSelectors';

export const maintenanceRoute = {
  name: 'Maintenance',
  title: createSelector(
    selectEntityDisplayName,
    name => generatePageTitle('Under Maintenance', name)
  ),
  selector: selectMaintenanceProps,
  component: Maintenance,
  onEnter: ensureAll([
    onEnterStoriesRoutes,
    async (state, nextLocation, onSuccess, onError) => {
      const { entitySubdomain } = nextLocation.params;
      await entityEffects
        .fetchRequestedOrCurrentEntity({
          requestedEntitySubdomain: entitySubdomain,
          currentEntity: selectCurrentEntity(state)
        })
        .then(async (entity: IEntity) => {
          await coreFeatureFlagEffects.getFlags().then(async flags => {
            if (flags && !flags['product-stories-maintenance-window']) {
              return onError(
                'Redirecting...',
                routerActions.replace.create({ pathname: storyListPath(entity.subdomain) })
              );
            }
            onSuccess();
          });
        });
    }
  ])
};
